import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { Injectable } from '@angular/core';
import { ICreditTypeService } from './icredit-type.service';
import { ApiService } from '../../shared/api/api.service';
import { CreditType } from './credit-type.model';
import { CreditTypeDto } from './dto/credit-type.dto';
import { CreditTypeSearchDto } from './dto/credit-type-search.dto';

@Injectable({ providedIn: 'root' })
export class CreditTypeService implements ICreditTypeService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public getCreditTypes = (): Promise<Array<CreditType>> => {
    return this._apiService.get('CE_CreditTypes').then((data: Array<CreditType>) => {
      return Promise.resolve(data);
    });
  };

  public getAllCreditTypes(search: CreditTypeSearchDto): Promise<PagedResultGeneric<CreditTypeDto>> {
    return this._apiService.getPaged('CE_CreditTypes', search);
  }
}
